/* eslint-disable @next/next/no-img-element */
import ICONS from 'utils/icons';

const Accordion = (props) => {
  const { onClick, question, isOpen, answer, classNameByLang } = props;

  const toggle = () => {
    onClick();
  };

  return (
    <div className="accordion___container">
      <button className="accordion___title" onClick={toggle} type="button">
        <div className={`d-flex font-size-16 gap-4 align-items-center ${classNameByLang}`} style={{textWrap: "break-word"}}>
          <img src={ICONS.playButtonGrey} alt="chevronDown" />
          {question}
        </div>
      </button>
      <div className={`${isOpen ? 'd-block' : 'd-none'} accordion___content ${classNameByLang}`} style={{textWrap: "break-word"}}>{answer}</div>
    </div>
  );
};

export default Accordion;
